// src/utils/validaciones.js

export function validarCampoTexto({
  objeto,
  campo,
  max,
  soloNumeros = false,
  estados,
  mensajes,
}) {
  const valor = objeto[campo];

  // Limitar por longitud
  if (valor.length > max) {
    estados[campo] = false;
    mensajes[campo] = `Máximo ${max} caracteres permitidos`;
    return;
  }

  // Validar que sea solo numérico (si se pide)
  if (soloNumeros && !/^\d*$/.test(valor)) {
    estados[campo] = false;
    mensajes[campo] = "Solo se permiten números";
    return;
  }

  // Si pasa todas las validaciones
  estados[campo] = true;
  mensajes[campo] = "";
}
